import { render, staticRenderFns } from "./DualGraphicsSecondPdfComponent.vue?vue&type=template&id=3e74a0f6&scoped=true"
import script from "./DualGraphicsSecondPdfComponent.vue?vue&type=script&lang=js"
export * from "./DualGraphicsSecondPdfComponent.vue?vue&type=script&lang=js"
import style0 from "./DualGraphicsSecondPdfComponent.vue?vue&type=style&index=0&id=3e74a0f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e74a0f6",
  null
  
)

export default component.exports